import { filterAvailableTimes } from '@myfunnow/web-core/time-filter'

import { getBranchList } from '@/service/branch'

const filterActionsComposition = props => {
  const { $axios } = useNuxtApp()

  let isDebounce = ref(props.isDebounce)
  let filterKey = ref(props.filterKey)
  let keyValue = ref(props.keyValue)
  let type = ref(props.type)
  let currentFilter = reactive(props.currentFilter || {})
  let currentTagFilter = reactive(props.currentTagFilter || {})
  const tempFilters = reactive({})
  const tempFilterTags = reactive({})
  const clearing = ref(false)
  const filterLoading = ref(false)
  const showClearBtn = ref(props.filterSelected || false)
  const filterTotalCount = ref(props.totalCount || 0)
  watch(props, currentValue => {
    isDebounce = ref(currentValue.isDebounce)
    filterKey = ref(currentValue.filterKey)
    keyValue = ref(currentValue.keyValue)
    type = ref(currentValue.type)
    currentFilter = reactive(currentValue.currentFilter || {})
    currentTagFilter = reactive(currentValue.currentTagFilter || {})
    filterTotalCount.value = currentValue.totalCount
  })

  const deleteNullFilter = filters => {
    const newFilter = { ...filters }
    for (const name in newFilter) {
      if (!newFilter[name]) {
        delete newFilter[name]
      }
    }
    return newFilter
  }

  const setTempFilters = filters => {
    for (const name in filters) {
      tempFilters[name] = filters[name]
    }
  }

  const getFilterTagParams = tagSettingMap => {
    const filterTags = []
    const mergeFilterTag = deleteNullFilter({ ...currentTagFilter, ...tagSettingMap })
    for (const name in mergeFilterTag) {
      const tagsText = mergeFilterTag[name].join(',')
      if (tagsText) {
        filterTags.push(`[${tagsText}]`)
      }
    }
    const filterTagsText = filterTags.join(',')
    return filterTagsText || false
  }

  // 清理在指定日期下已不可選的時間
  const cleanupUnavailableFilterTimes = params => {
    if (!params.starttime || !params.filter_times) {
      return
    }

    params.filter_times = filterAvailableTimes(params.filter_times, params.starttime)
    if (params.filter_times.length === 0) {
      delete params.filter_times
    }
  }

  const fetchTempFilterData = () => {
    filterLoading.value = true
    const filterParams = deleteNullFilter({ ...currentFilter, ...tempFilters })
    const tagFilters = getFilterTagParams(tempFilterTags)

    cleanupUnavailableFilterTimes(filterParams)

    Object.assign(filterParams, { filter_tags: tagFilters ? `[${tagFilters}]` : undefined })

    if (props.isBranchCardMode) {
      return getBranchList($axios, { ...filterParams })
        .then(res => {
          if (res.code === 0) {
            filterTotalCount.value = res.total_count
            filterLoading.value = false
          }
          return res
        })
        .catch(error => {
          console.error('fetchTempFilterData: error', error)
          filterLoading.value = false
        })
    }

    return $axios
      .$get(`/pub/product`, { params: filterParams })
      .then(res => {
        if (res.code === 0) {
          filterTotalCount.value = res.total_count
          filterLoading.value = false
        }
        return res
      })
      .catch(error => {
        console.error('fetchTempFilterData: error', error)
        filterLoading.value = false
      })
  }

  const getFilterParams = filters => {
    const filterparams = {}
    keyValue.value.forEach((value, idx) => {
      filterparams[value] = filters[idx]
    })
    return filterparams
  }

  const setTempFilterTags = filters => {
    tempFilterTags[filterKey.value] = filters
  }

  const setSelectedFilter = filters => {
    let filterMap = {}
    if (type.value === 'tags') {
      setTempFilterTags(filters)
    } else {
      filterMap = getFilterParams(filters)
      setTempFilters(filterMap)
    }

    if (isDebounce.value) {
      fetchTempFilterData()
    }
  }

  const changeClearingStatus = status => {
    clearing.value = status || false
  }

  const doClearData = () => {
    changeClearingStatus(true)
  }

  const updateClearBtn = showStatus => {
    showClearBtn.value = showStatus
    if (!showStatus) {
      changeClearingStatus(false)
    }
  }

  const getConfirmFilterData = () => {
    const activated = showClearBtn.value
    const returnParams = Object.assign({}, { ...(type.value === 'tags' ? tempFilterTags : tempFilters) })
    const filterResponse = Object.assign({}, { params: returnParams, activated: activated, totalCount: filterTotalCount.value })

    filterResponse.index = props.index || 0
    if (type.value) {
      filterResponse.type = type.value
    }

    if (filterKey.value) {
      filterResponse.filterKey = filterKey.value
    }

    return filterResponse
  }

  return {
    showClearBtn,
    clearing,
    filterLoading,
    filterTotalCount,
    tempFilters,
    setSelectedFilter,
    doClearData,
    updateClearBtn,
    getConfirmFilterData,
  }
}

export default filterActionsComposition
